import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createClientNoticesReduceObject } from './clientNotices/reducer';

import { createReduceObject as createReferenceListsReduceObject } from './referenceLists/reducer';
import referenceListsSaga from './referenceLists/sagas/referenceListsSaga';

import { createReduceObject as createCountsReduceObject } from './counts/reducer';
import countsSaga from './counts/sagas/countsSaga';

import { createReduceObject as createCaptchaReduceObject } from './captcha/reducer';
import captchaSaga from './captcha/sagas/captchaSaga';

export default [
  // Lists
  ...createCombineMapItem('clientNotices', createClientNoticesReduceObject, []),
  ...createCombineMapItem('referenceLists', createReferenceListsReduceObject, [
    referenceListsSaga
  ]),
  ...createCombineMapItem('counts', createCountsReduceObject, [countsSaga]),
  ...createCombineMapItem('captcha', createCaptchaReduceObject, [captchaSaga])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/reducers/static/states/reducersMap.js